import { type CAPITAL_PARTNER_NETWORK_CONTENT } from '../content';
import {
  ContentContainer,
  Section,
  SectionEyebrow,
  SectionIntro,
  SectionLead,
  SectionTitle,
  StepCard,
  StepGrid,
  StepNumber,
  SurfaceText,
  SurfaceTitle,
} from '../styles';

type HowItWorksCopy = (typeof CAPITAL_PARTNER_NETWORK_CONTENT)['howItWorks'];

type HowItWorksSectionProps = {
  copy: HowItWorksCopy;
};

export default function HowItWorksSection({ copy }: HowItWorksSectionProps) {
  return (
    <Section>
      <ContentContainer>
        <SectionIntro $wide>
          <SectionEyebrow>{copy.eyebrow}</SectionEyebrow>
          <SectionTitle>{copy.title}</SectionTitle>
          <SectionLead>
            The process is designed to be practical, selective, and grounded in fit.
          </SectionLead>
        </SectionIntro>
        <StepGrid>
          {copy.steps.map((step) => (
            <StepCard key={step.step}>
              <StepNumber>{step.step}</StepNumber>
              <SurfaceTitle>{step.title}</SurfaceTitle>
              <SurfaceText>{step.body}</SurfaceText>
            </StepCard>
          ))}
        </StepGrid>
      </ContentContainer>
    </Section>
  );
}
